import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from './types';

export const RejectedTransactionsIcon: FC<IconProps> = ({ width = 24, height = 24 }) => {
  return (
    <SvgIcon width={width} height={height} viewBox={[0, 0, width, height].join(' ')} fill="none" stroke="none" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.429 4.71763H2.14328C1.66917 4.71763 1.28613 5.10067 1.28613 5.57478V21.8605C1.28613 22.3346 1.66917 22.7176 2.14328 22.7176H18.429C18.9031 22.7176 19.2861 22.3346 19.2861 21.8605V5.57478C19.2861 5.10067 18.9031 4.71763 18.429 4.71763ZM17.3576 20.7891H3.2147V6.64621H17.3576V20.7891ZM21.8576 1.28906H5.35756C5.2397 1.28906 5.14328 1.38549 5.14328 1.50335V3.00335C5.14328 3.12121 5.2397 3.21763 5.35756 3.21763H20.7861V18.6462C20.7861 18.7641 20.8826 18.8605 21.0004 18.8605H22.5004C22.6183 18.8605 22.7147 18.7641 22.7147 18.6462V2.14621C22.7147 1.6721 22.3317 1.28906 21.8576 1.28906ZM6.32185 13.0212H14.2504V14.7355H6.32185V13.0212Z"/>
    </SvgIcon>
  );
};
